import { AnimationOnScroll } from "react-animation-on-scroll";

export default function SquareCard({ title, img, index }) {
  return (
    <AnimationOnScroll animateIn={"animate__zoomIn"} delay={index * 80}>
      <div className=" h-52 w-44 md:h-60 md:w-52 bg-color2 flex flex-col items-center">
        <h4 className={`justify-self-start text-xl mb-4 mt-7`}>{title}</h4>
        <div className=" pb-4 px-4 flex justify-center items-center h-full">
          <img className=" w-24 md:w-32" src={img} alt={title + " icon"} />
        </div>
      </div>
    </AnimationOnScroll>
  );
}
